import * as React from "react";
import { useEffect, useState, useContext, useRef } from "react";
import axios from "axios";
import liff from "@line/liff";
import { initializeApp } from "firebase/app";
import { useHistory, Link, Route } from "react-router-dom";
import { auth } from "./firebase";
import {
  createUserWithEmailAndPassword,
  sendEmailVerification,
} from "firebase/auth";
import Timeline from "@mui/lab/Timeline";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
import TimelineOppositeContent from "@mui/lab/TimelineOppositeContent";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import Paper from "@mui/material/Paper";
import Badge from "@mui/material/Badge";
import { styled } from "@mui/material/styles";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import TextField from "@mui/material/TextField";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import "./App.css";
import { TbMovie } from "react-icons/tb";
import { create } from "@mui/material/styles/createTransitions";
import LoadingImg1 from "./LoadingImg1";
import { passFilterLogic } from "@mui/x-data-grid/internals";

const style = {
  position: "absolute",
  top: "0%",
  width: "100%",
  height: "100%",
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
};

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "60vw",
  boxShadow: 24,
  p: 4,
};

function LoginUser(props) {
  const [exChangeModal, setExChangeModal] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [success, setSuccess] = useState("");
  const [inputError, setInputError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const history = useHistory();

  const headers = {
    "Content-Type": "application/json",
    //Authorization: `Bearer ${authToken}`
  };

  const inputRef = useRef(null);
  const handleChange = () => {
    if (inputRef.current) {
      const ref = inputRef.current;
      if (!ref.validity.valid) {
        setInputError(true);
      } else {
        setInputError(false);
      }
    }
  };
  const countPw = () => {
    if (password.length >= 0 && password.length < 7) {
      setMessage(
        "パスワードが短すぎます。パスワードは8文字以上で入力してください。"
      );
    } else {
      setMessage("");
    }
  };

  const validatePw = () => {
    let isValid = true;
    if (password !== "" && confirmPassword !== "") {
      if (password !== confirmPassword) {
        isValid = false;
        setMessage("パスワードが異なります");
      }
    }
    return isValid;
  };

  const entry = async () => {
    setIsLoading(true);
    setError("");
    if (validatePw()) {
      const user = {
        email_address: email,
      };
      axios
        .post(
          "https://us-central1-point-ex-9709a.cloudfunctions.net/pointex/getUser2",
          user,
          { headers: headers }
        )
        .then((res) => {
          if (res.data.items.length !== 0) {
            createUserWithEmailAndPassword(auth, email, password)
              .then(() => {
                const ActionCodeSettiings = {
                  url: `https://point-ex-9709a.web.app/history/mail/${email}`,
                };
                sendEmailVerification(auth.currentUser, ActionCodeSettiings);
                setSuccess("入力したメールアドレスに確認メールを送信しました");
                setEmail("");
                setPassword("");
                setConfirmPassword("");
              })
              .catch((err) => {
                console.log(err.code);
                switch (err.code) {
                  case "auth/invalid-email":
                    setError("メールアドレスの形式が間違っています");
                    setIsLoading(false);
                    break;
                  case "auth/email-already-in-use":
                    setError("既に連携済みです");
                    setIsLoading(false);
                    break;
                  case "auth/weak-password":
                    setError("パスワードが短すぎます");
                    setIsLoading(false);
                    break;
                  default:
                    setError("エラーが発生しました。");
                    setIsLoading(false);
                }
              });
          } else {
            const create = {
              email_address: email,
              phone_number: "",
            };
            axios
              .post(
                "https://us-central1-point-ex-9709a.cloudfunctions.net/pointex/create-user",
                create,
                { headers: headers }
              )
              .then((res) => {
                createUserWithEmailAndPassword(auth, email, password)
                  .then(() => {
                    const ActionCodeSettiings = {
                      url: `https://point-ex-9709a.web.app/history/mail/${email}`,
                    };
                    sendEmailVerification(
                      auth.currentUser,
                      ActionCodeSettiings
                    );
                    setSuccess(
                      "入力したメールアドレスに確認メールを送信しました"
                    );
                    setEmail("");
                    setPassword("");
                    setConfirmPassword("");
                  })
                  .catch((err) => {
                    console.log(err.code);
                    switch (err.code) {
                      case "auth/invalid-email":
                        setError("メールアドレスの形式が間違っています");
                        setIsLoading(false);
                        break;
                      case "auth/email-already-in-use":
                        setError("既に連携済みです");
                        setIsLoading(false);
                        break;
                      case "auth/weak-password":
                        setError("パスワードが短すぎます");
                        setIsLoading(false);
                        break;
                      default:
                        setError("エラーが発生しました。");
                        setIsLoading(false);
                    }
                  });
                setIsLoading(false);
              })
              .catch((err) => {
                console.log("b", err.code);
                setError("メールアドレスの形式が間違っています");
                setIsLoading(false);
              });
          }
        })
        .catch((err) => {
          console.log("a", err.code);
          setError("エラーが発生しました");
          setIsLoading(false);
        });
    }
  };

  const handleExChangeModaleOpen = () => {
    setExChangeModal(true);
  };
  const handleExChangeModaleClose = () => {
    setExChangeModal(false);
  };

  const move = () => {
    setError("");
    setSuccess("");
    history.push("/history");
  };

  return (
    <>
      <Button
        variant="contained"
        fullWidth
        color="success"
        onClick={() => {
          handleExChangeModaleOpen();
        }}
      >
        findoutとアカウント連携する
      </Button>
      <Modal
        hideBackdrop
        open={exChangeModal}
        aria-labelledby="title"
        aria-describedby="description"
      >
        <Paper
          sx={{
            overflowY: "auto",
            overflowX: "hidden",
            ...style,
          }}
        >
          <Grid className="timeline">
            <Grid container direction="column" alignItems="center">
              <Modal
                hideBackdrop
                open={isLoading}
                aria-labelledby="title"
                aria-describedby="description"
              >
                <Paper sx={{ ...modalStyle }}>
                  <LoadingImg1 />
                </Paper>
              </Modal>
              <Grid marginTop={3}>
                <Typography variant="h6">
                  findoutとアカウント連携する
                </Typography>
              </Grid>
              {success && (
                <Typography variant="h6" color="success" sx={{ marginTop: 3 }}>
                  {success}
                </Typography>
              )}
              {error && (
                <Typography variant="h6" color="error" sx={{ marginTop: 3 }}>
                  {error}
                </Typography>
              )}
              {password === confirmPassword
                ? ""
                : message && (
                    <Typography
                      variant="h6"
                      color="error"
                      sx={{ marginTop: 3 }}
                    >
                      {message}
                    </Typography>
                  )}
              <Grid width={"80%"}>
                <Typography variant="subtitle1" sx={{ marginTop: 5 }}>
                  Goody!TVで使用しているメールアドレスを入力
                </Typography>
                <TextField
                  margin="normal"
                  type="email"
                  fullWidth
                  value={email}
                  required
                  label="メールアドレス"
                  placeholder="メールアドレスを入力してください。"
                  onChange={(e) => setEmail(e.target.value)}
                />
              </Grid>
              <Grid width={"80%"}>
                <Typography variant="subtitle1" sx={{ marginTop: 3 }}>
                  パスワードを入力(8文字以上)
                </Typography>
                <TextField
                  margin="normal"
                  type="password"
                  fullWidth
                  value={password}
                  required
                  inputProps={{ minLength: 8 }}
                  label="パスワード(8文字以上)"
                  placeholder="パスワード(8文字以上)を入力してください。"
                  onChange={(e) => {
                    setPassword(e.target.value);
                    handleChange();
                    countPw();
                  }}
                />
              </Grid>
              <Grid width={"80%"}>
                <Typography variant="subtitle1" sx={{ marginTop: 3 }}>
                  パスワードを再入力
                </Typography>
                <TextField
                  margin="normal"
                  type="password"
                  fullWidth
                  value={confirmPassword}
                  required
                  inputProps={{ minLength: 8 }}
                  inputRef={inputRef}
                  label="パスワード(確認)"
                  placeholder="パスワード(確認)"
                  onChange={(e) => {
                    setConfirmPassword(e.target.value);
                    handleChange();
                    validatePw();
                  }}
                />
              </Grid>
            </Grid>

            <Grid
              marginTop={10}
              marginBottom={3}
              container
              direction="column"
              alignItems="center"
            >
              {success ? (
                <Grid width={"80%"}>
                  <Button
                    variant="contained"
                    fullWidth
                    color="success"
                    onClick={() => {
                      move();
                    }}
                  >
                    もどる
                  </Button>
                </Grid>
              ) : (
                <Grid width={"80%"}>
                  {email !== "" &&
                  password.length >= 8 &&
                  confirmPassword.length >= 8 ? (
                    <Button
                      variant="contained"
                      fullWidth
                      color="success"
                      onClick={() => {
                        entry();
                      }}
                    >
                      アカウント連携する
                    </Button>
                  ) : (
                    <Button
                      variant="contained"
                      fullWidth
                      color="success"
                      disabled
                    >
                      アカウント連携する
                    </Button>
                  )}
                </Grid>
              )}
            </Grid>
          </Grid>
        </Paper>
      </Modal>
    </>
  );
}
export default LoginUser;
